import type { U3130FindProjectItem, U3130HonorariumItem, U3130Timesheet } from "../U3130TimesheetModel";

function honorariumRowIncludeSubProject(row: U3130HonorariumItem, admIncludeSubProjectEnabled: boolean): boolean {
  if (!admIncludeSubProjectEnabled) return false;
  const project = row.project as U3130FindProjectItem | undefined;
  if (!project || !("includeSubProjet" in project)) return false;
  const v = project.includeSubProjet;
  return v === true || (typeof v === "string" && v === "true");
}

export type U3130HonorariaValidationMessages = {
  project: string;
  subproject: string;
  task: string;
};

export type U3130TimesheetSubprojectSaveOptions = {
  /** Si false (personnalisation `admIncludeSubProject` ≠ `"true"`), ne jamais exiger de sous-projet. */
  admIncludeSubProjectEnabled?: boolean;
};

/**
 * Erreurs par clé alignées sur U2000AutoCompleteInput (suffixe `.id`) et U2000ComboBox (`taskType`).
 */
export function validateHonorariaLinesForSave(
  data: U3130Timesheet | null | undefined,
  messages: U3130HonorariaValidationMessages,
  options?: U3130TimesheetSubprojectSaveOptions,
): Record<string, string> {
  const errors: Record<string, string> = {};
  const admIncludeSubProjectEnabled = options?.admIncludeSubProjectEnabled ?? true;
  const list = data?.honoraria ?? [];
  list.forEach((row, i) => {
    const base = `honoraria.${i}`;
    const projectId = row.projectId?.trim() || row.project?.id?.trim() || "";
    if (!projectId) {
      errors[`${base}.project.id`] = messages.project;
    }
    if (honorariumRowIncludeSubProject(row, admIncludeSubProjectEnabled)) {
      const sub = row as U3130HonorariumItem & { subproject?: { id?: string } };
      const subId = row.subprojectId?.trim() || sub.subproject?.id?.trim() || "";
      if (!subId) {
        errors[`${base}.subproject.id`] = messages.subproject;
      }
    }
    if (!row.taskType?.trim()) {
      errors[`${base}.taskType`] = messages.task;
    }
  });
  return errors;
}

export function honorariaTabHasValidationErrors(errors: Record<string, string>): boolean {
  return Object.keys(errors).some((k) => k.startsWith("honoraria."));
}
